import { attachmentsApi } from './queries/attachments'
import { authApi } from './queries/auth'
import { cartApi } from './queries/cart'
import { claimRecordsApi } from './queries/claimRecords'
import { configApi } from './queries/config'
import { guestCustomerApi } from './queries/guestCustomer'
import { insurersApi } from './queries/insurers'
import {
  cancelClaimSlice,
  claimStatusSlice,
  prescriptionFileSlice,
  workflowSlice,
  ctaSlice,
  connectorSlice,
  formsSlice,
  claimSubmitSlice,
  insuranceMemberSlice,
  overviewWidgetSlice,
} from './slices'

export const reducers = {
  [authApi.reducerPath]: authApi.reducer,
  [insurersApi.reducerPath]: insurersApi.reducer,
  [claimRecordsApi.reducerPath]: claimRecordsApi.reducer,
  [configApi.reducerPath]: configApi.reducer,
  [attachmentsApi.reducerPath]: attachmentsApi.reducer,
  [cartApi.reducerPath]: cartApi.reducer,
  [guestCustomerApi.reducerPath]: guestCustomerApi.reducer,
  [prescriptionFileSlice.name]: prescriptionFileSlice.reducer,
  [cancelClaimSlice.name]: cancelClaimSlice.reducer,
  [claimStatusSlice.name]: claimStatusSlice.reducer,
  [claimSubmitSlice.name]: claimSubmitSlice.reducer,
  [workflowSlice.name]: workflowSlice.reducer,
  [ctaSlice.name]: ctaSlice.reducer,
  [connectorSlice.name]: connectorSlice.reducer,
  [formsSlice.name]: formsSlice.reducer,
  [insuranceMemberSlice.name]: insuranceMemberSlice.reducer,
  [overviewWidgetSlice.name]: overviewWidgetSlice.reducer,
}

export const initialState = {
  [prescriptionFileSlice.name]: prescriptionFileSlice.getInitialState(),
}
